import React, { useState } from "react";
import { Tabs, theme } from "antd";
import SaleList from "../components/sale-list/SaleList";
import SaleSkimList from "../components/sale-list/SaleSkimList";
import { USER_GROUP } from "../constants/string";
import { useUserContext } from "../hooks/UserSettingProvider";

export default function SaleListView() {
  const tableRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useUserContext();
  const hasPermission = (target) => (user && user.groups &&  user.groups.length > 0 ? user.groups.find((group) => group === target) : true)

  const items = [
    {
      key: "latexsaleslist",
      label: "รายการขายน้ำยางข้น",
      children: <SaleList isDone={false} ref={tableRef} />,
      permission : true,
    },
    {
      key: "skimsaleslist",
      label: "รายการขายสกิม",
      children: <SaleSkimList isDone={false} ref={tableRef} />,
      permission : true,
    },
  ];

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="latexsaleslist"
        items={items.filter((item) => item.permission == true)}
        style={{ marginTop: 15 }}
      />
      {isLoading && (
        <p style={{ textAlign: "center", color: "gray" }}>กำลังโหลดข้อมูล...</p>
      )}
    </div>
  );
}
